import { SectionNotes } from 'services/api/vehicle-sections/types';

export const useTireMessage = (notes?: SectionNotes, imageType?: string) => {
  const isTire = imageType?.endsWith('_tire');
  if (!isTire) return notes?.message;
  return notes?.ai_message || notes?.message;
};
